import { styled } from 'styled-components';

import { Container } from '../../../components/Common';
import { flexCenter } from '../../../utils/styled/mixins';

export const ContentContainer = styled(Container)`
  flex: 1;
  ${flexCenter}
`;
